/**
 * 将callbackMap设置在上层的window中
 * 避免在iframe中使用bindBroadcast交互无法捕获的问题
 */
export default function initBoradCast() {
  window.callbackMap = {};

  window.onNativeBroadcast = function (paramStr) {
    const params = JSON.parse(paramStr);
    const { action } = params;
    const { data } = params;
    const callbacks = window.callbackMap[action];
    const newCallbackSet = [];

    // fix Uncaught TypeError: Object.values is not a function JavaScript
    // callbacks不能是null或者undefined
    if (callbacks) {
      Object.values(callbacks).forEach((callback: any) => {
        if (!callback(data)) {
          newCallbackSet.push(callback);
        }
      });
    }

    window.callbackMap[action] = newCallbackSet;
  };

  window.bindBroadcast = function (action, callback) {
    if (!window.callbackMap[action]) {
      window.callbackMap[action] = [];
    }

    if (window.callbackMap[action].indexOf(callback) < 0) {
      window.callbackMap[action].push(callback);
    }
  };

  window.sendWebViewBroadcast = function (action, data) {
    if (window.MaiMai_Native && window.MaiMai_Native.native_send_broadcast) {
      window.MaiMai_Native.native_send_broadcast(
        'broadcast_to_webview',
        JSON.stringify({
          action,
          data,
        })
      );
    }
  };

  window.unbindBroadcast = function (action, callback) {
    if (window.callbackMap[action]) {
      if (callback) {
        const index = window.callbackMap[action].indexOf(callback);
        window.callbackMap[action].splice(index, 1);
      } else {
        delete window.callbackMap[action];
      }
    }
  };
}
